"use client";

import { createContext, use } from "react";
import type { Doc } from "@convex/_generated/dataModel";

export const AdminViewerContext = createContext<Doc<"users"> | null>(null);

export function useAdminViewer(): Doc<"users"> | undefined {
  return use(AdminViewerContext) ?? undefined;
}
